import PropTypes from 'prop-types';
import store from '../../../store';

export const checkPermission = (action, subjectClass, operator = 'OR') => {
  if (action === '' || action === true || action === 'true') {
    return true;
  } else if (action === false || action === 'false') {
    return false;
  }

  let can;

  if (localStorage.getItem('accessToken') !== null) {
    let ownedSubjectClasses = [];

    const { permissions } = store.getState().viewConfig.profile.attributes;

    if (!permissions) {
      return false;
    }

    const requiredActions = action.split(',');
    const requiredSubjectClasses = subjectClass.split(',');

    requiredActions.forEach((requiredAction) => {
      const subjects = permissions.can[requiredAction];

      if (subjects) {
        ownedSubjectClasses = ownedSubjectClasses.concat(subjects);
      } else if (operator === 'AND') {
        can = false;
      }
    });

    if (can === undefined) {
      if (operator === 'OR') {
        can = requiredSubjectClasses.some(subj => ownedSubjectClasses.find(owned => owned === subj));
      } else {
        can = requiredSubjectClasses.every(subj => ownedSubjectClasses.find(owned => owned === subj));
      }
    }
  }

  return !!can;
};

const Can = ({
  action, subjectClass, operator = 'OR', cannot, children
}) => {
  const can = checkPermission(action, subjectClass, operator);

  return can ? (<div>{children}</div>) : (<div>{cannot}</div>);
};

Can.propTypes = {
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  subjectClass: PropTypes.string,
  operator: PropTypes.oneOf(['OR', 'AND']),
  cannot: PropTypes.any
};

export default Can;
